import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function getByRegister(registerId: string | number) {
  const response = await http
    .getData(`/register/${registerId}/pemantauan-anestesi`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/pemantauan-anestesi/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function create(data: any) {
  const response = await http
    .postData("/pemantauan-anestesi", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`/pemantauan-anestesi/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/pemantauan-anestesi/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// TTV
async function addTtv(pemantauanId: number, data: any) {
  const response = await http
    .postData(`/pemantauan-anestesi/${pemantauanId}/ttv`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateTtv(pemantauanId: number, ttvId: number, data: any) {
  const response = await http
    .putData(`/pemantauan-anestesi/${pemantauanId}/ttv/${ttvId}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteTtv(pemantauanId: number, ttvId: number) {
  const response = await http
    .deleteData(`/pemantauan-anestesi/${pemantauanId}/ttv/${ttvId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Obat
async function addObat(pemantauanId: number, data: any) {
  const response = await http
    .postData(`/pemantauan-anestesi/${pemantauanId}/obat`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateObat(pemantauanId: number, obatId: number, data: any) {
  const response = await http
    .putData(`/pemantauan-anestesi/${pemantauanId}/obat/${obatId}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteObat(pemantauanId: number, obatId: number) {
  const response = await http
    .deleteData(`/pemantauan-anestesi/${pemantauanId}/obat/${obatId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Workflow
async function finalisasi(id: number, data: any) {
  const response = await http
    .postData(`/pemantauan-anestesi/${id}/finalisasi`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function kumulatifObat(id: number) {
  const response = await http
    .getData(`/pemantauan-anestesi/${id}/kumulatif-obat`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Signing
async function sign(id: number, data: { role: string; password: string }) {
  const response = await http
    .postData(`/pemantauan-anestesi/${id}/sign`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// PDF
function printPdf(id: number) {
  window.open(
    `${http.getAPI()}/pemantauan-anestesi/${id}/pdf`,
    "_blank"
  );
}

export default {
  getByRegister,
  find,
  create,
  update,
  destroy,
  addTtv,
  updateTtv,
  deleteTtv,
  addObat,
  updateObat,
  deleteObat,
  finalisasi,
  kumulatifObat,
  sign,
  printPdf,
};
